module.exports = __webpack_public_path__ + "static/media/certificate-banner.e3a2597b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate-banner.png
// module id = 2614
// module chunks = 1